var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-wrapper" }, [
    _c("div", { staticClass: "container-xl" }, [
      _c("div", { staticClass: "page-header d-print-none" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "page-pretitle" }, [
              _vm._v(_vm._s(_vm.$auth.activeCompany.companyName)),
            ]),
            _c("h2", { staticClass: "page-title" }, [_vm._v("Key Features")]),
          ]),
        ]),
      ]),
      !_vm.loaded
        ? _c("div", { staticClass: "page-body" }, [_vm._m(0)])
        : _c(
            "div",
            { staticClass: "page-body" },
            [
              !_vm.$auth.activeCompany.isFeatured
                ? _c("upgrade-box", { staticClass: "mb-4" }, [
                    _c("p", [
                      _vm._v(
                        " Your feature selections are being saved, but they are "
                      ),
                      _c("strong", [_vm._v("not currently shown")]),
                      _vm._v(
                        " to potential customers in the directory. Upgrade to a featured listing to display your selections on your listing. "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.loadError
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _vm._v(
                      " Something went wrong loading your Key Features. Please refresh the page to try again. "
                    ),
                  ])
                : _vm._e(),
              _vm.saveError
                ? _c(
                    "div",
                    { staticClass: "alert alert-danger alert-dismissible" },
                    [
                      _vm._v(
                        " One of your selections could not be saved. It has been reverted. Please try again. "
                      ),
                      _c("button", {
                        staticClass: "btn-close",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.saveError = false
                          },
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              !_vm.loadError && _vm.categories.length === 0
                ? _c("div", { staticClass: "card" }, [_vm._m(1)])
                : _vm._e(),
              !_vm.loadError
                ? _vm._l(_vm.categories, function (category) {
                    return _c(
                      "div",
                      { key: category.categoryId, staticClass: "card mb-4" },
                      [
                        _c("div", { staticClass: "card-header" }, [
                          _c("div", { staticClass: "card-title" }, [
                            _vm._v(_vm._s(category.categoryName)),
                          ]),
                          _c("div", { staticClass: "card-options" }, [
                            _c("span", { staticClass: "text-muted small" }, [
                              _vm._v(
                                " " +
                                  _vm._s(category.selectedCount) +
                                  " of " +
                                  _vm._s(category.totalCount) +
                                  " features selected "
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "progress progress-sm card-progress" },
                          [
                            _c("div", {
                              staticClass: "progress-bar bg-success",
                              style: {
                                width: _vm.progressPercent(category) + "%",
                              },
                              attrs: { role: "progressbar" },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(category.features, function (feature) {
                            return _c(
                              "div",
                              { key: feature.featureId, staticClass: "mb-3" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "form-check form-switch" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: feature.value,
                                          expression: "feature.value",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.savingIds.includes(
                                          feature.featureId
                                        ),
                                      },
                                      domProps: {
                                        checked: Array.isArray(feature.value)
                                          ? _vm._i(feature.value, null) > -1
                                          : feature.value,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = feature.value,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    feature,
                                                    "value",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    feature,
                                                    "value",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(feature, "value", $$c)
                                            }
                                          },
                                          function ($event) {
                                            return _vm.toggleFeature(
                                              category,
                                              feature
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "form-check-label" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(feature.name) + " "
                                        ),
                                        feature.description
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  cursor: "help",
                                                  "vertical-align": "middle",
                                                },
                                                attrs: {
                                                  title: feature.description,
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass:
                                                      "icon icon-tabler icon-tabler-info-circle ms-1 text-muted",
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                      width: "16",
                                                      height: "16",
                                                      viewBox: "0 0 24 24",
                                                      "stroke-width": "2",
                                                      stroke: "currentColor",
                                                      fill: "none",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        stroke: "none",
                                                        d: "M0 0h24v24H0z",
                                                        fill: "none",
                                                      },
                                                    }),
                                                    _c("circle", {
                                                      attrs: {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "9",
                                                      },
                                                    }),
                                                    _c("line", {
                                                      attrs: {
                                                        x1: "12",
                                                        y1: "8",
                                                        x2: "12.01",
                                                        y2: "8",
                                                      },
                                                    }),
                                                    _c("polyline", {
                                                      attrs: {
                                                        points:
                                                          "11 12 12 12 12 16 13 16",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.savingIds.includes(
                                          feature.featureId
                                        )
                                          ? _c("span", {
                                              staticClass:
                                                "spinner-border spinner-border-sm ms-2 text-muted",
                                              attrs: { role: "status" },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center py-5" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border text-primary",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body text-center py-5" }, [
      _c("p", { staticClass: "text-muted mb-0" }, [
        _vm._v(
          " There are no key feature categories available for your listings at this time. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }